import { Heading, IconButton } from 'copilot-design-system';
import { ComponentProps, FC } from 'react';

import {
  DRAWER_ACTION_CONFIGS,
  DRAWER_LABELS,
  DrawerId,
} from 'src/context/contextBarContext';

type IconButtonIcon = ComponentProps<typeof IconButton>['icon'];

type DrawerContentHeaderProps = {
  drawerId: DrawerId;
  onAction?: () => void;
};

export const DrawerContentHeader: FC<DrawerContentHeaderProps> = ({
  drawerId,
  onAction,
}) => {
  const actionConfig = DRAWER_ACTION_CONFIGS[drawerId];
  const label = DRAWER_LABELS[drawerId];

  return (
    <div className="flex justify-between items-center px-4 min-h-[60px] flex-shrink-0 border border-solid border-l-0 border-r-0 border-t-0 border-non-hover-border">
      <Heading size="base">{label}</Heading>
      {actionConfig && onAction && (
        <IconButton
          className="hover:cursor-pointer p-1 hover:bg-secondary-hover"
          label={actionConfig.label}
          onClick={(e) => {
            e.stopPropagation();
            onAction();
          }}
          icon={actionConfig.icon as IconButtonIcon}
          variant="minimal"
        />
      )}
    </div>
  );
};
